import React, { useEffect, useState } from 'react'
import { store } from '../../../redux/store';
import { Button, Input, Modal, Table, ConfigProvider, notification, Radio, Switch, Card } from 'antd';
import { PlusOutlined, DeleteOutlined, MinusOutlined } from '@ant-design/icons';
import zhCN from 'antd/es/locale/zh_CN';
import Serach from '../../generalComponent/search';
import { useNavigate } from 'react-router-dom';
//引入axios 进行服务器接口请求
import axios from "axios";
export default function Attribute() {
  const [attributeValObj, setAttributeValObj] = useState({});
  const [attributeData, setAttributeData] = useState([]);
  const [api, contextHolder] = notification.useNotification();
  const openNotificationWithIcon = (type, title, msg) => {
    api[type]({
      message: title,
      description: msg,
      placement: 'top',
      duration: 1
    });
  };

  const initialFields = { 'name': '', 'type': '' };
  const initState = { 'id': '', 'attributeName': '', 'attributeType': 1, 'attributeName_isVisible': false, 'attributeType_isVisible': false };
  const [state, setState] = useState(initState);
  const [dataSource, setDataSource] = useState([]);
  const [query, setQuery] = useState({});
  const [selectedRowKeys, setSelectedRowKeys] = useState([]);
  const [modalTitle, setModalTitle] = useState("");

  useEffect(() => {
    queryList({});
  }, []); // 空数组确保只在挂载时设置观察者

  let navigate = useNavigate();

  const token = store.getState().uData.token;
  function queryList(data) {
    //请求后台接口
    // / 设置全局的Authorization头
    axios.defaults.headers.common['token'] = token;
    axios.post('/api/attribute/list',
      data, {
      headers: {
        'Content-Type': 'application/json'
      }
    }
    ).then(
      response => {
        if (response.data.code === "200") {
          setDataSource(response.data.data);
          setSelectedRowKeys([])
        } else {
          setDataSource({});
          setSelectedRowKeys([])
        }

      },
      error => {
        navigate("/error");
      }
    )
  }

  const onSelectChange = newSelectedRowKeys => {
    setSelectedRowKeys(newSelectedRowKeys);
  };
  const rowSelection = {
    selectedRowKeys,
    onChange: onSelectChange
  };

  const [open, setOpen] = useState(false);

  //查询数据详情
  function modifyAttribute(id) {
    const params = new URLSearchParams();
    params.append('id', id);
    axios.defaults.headers.common['token'] = token;
    axios.post('/api/attribute/find',
      params
    ).then(
      response => {
        if (response.data.code === "200") {
          setState(response.data.data);
          const attributeInfoArr = response.data.data.attributes;
          let attributeDataArr = [];
          //组装货品属性数据
          for (let i = 0; i < attributeInfoArr.length; i++) {
            let currentTime = Date.now() + i;
            attributeDataArr.push(
              { key: currentTime }
            )
            setAttributeValObj(prevState => ({ ...prevState, ['k_' + currentTime]: attributeInfoArr[i] }));
          }
          setAttributeData(attributeDataArr);
          setModalTitle("编辑货品信息")
          setOpen(true);
        } else {
          openNotificationWithIcon('error', '消息提示', '数据查询失败！')
        }

      },
      error => {
        navigate("/error");
      }
    )
  }

  const showModal = () => {
    setState(initState);
    setModalTitle("新增属性信息")
    setOpen(true);
  };
  const handleOk = () => {
    handleAddOrModify();
  };
  const handleCancel = () => {
    setAttributeData([]);
    setAttributeValObj({});
    setOpen(false);
  };

  function handleBatchDel() {
    const ids = selectedRowKeys;
    if (ids.length === 0) {
      openNotificationWithIcon('warning', '消息提示', '请先选择要删除的数据!')
      return;
    }
    //请求后台接口
    const url = '/api/attribute/del';
    const success_msg = '数据删除成功';
    const error_msg = '数据删除失败！';
    axios.defaults.headers.common['token'] = token;
    const data = {
      ids
    }
    axios.defaults.headers.common['token'] = token;
    axios.post(url,
      data, {
      headers: {
        'Content-Type': 'application/json'
      }
    }
    ).then(
      response => {
        if (response.data.code === "200") {
          setSelectedRowKeys([]);
          queryList(query);
          openNotificationWithIcon('success', '消息提示', success_msg)
        } else {
          openNotificationWithIcon('error', '消息提示', error_msg)
        }

      },
      error => {
        navigate("/error");
      }
    )
  }

  function deleteAttribute(id) {
    if (id === "") {
      openNotificationWithIcon('warning', '消息提示', '请先选择要删除的数据!')
      return;
    }

    //请求后台接口
    const url = '/api/attribute/del';
    const success_msg = '数据删除成功';
    const error_msg = '数据删除失败！';
    const ids = [];
    ids.push(id);
    const data = {
      ids
    }
    axios.defaults.headers.common['token'] = token;
    axios.post(url,
      data, {
      headers: {
        'Content-Type': 'application/json'
      }
    }
    ).then(
      response => {
        if (response.data.code === "200") {
          queryList(query);
          openNotificationWithIcon('success', '消息提示', success_msg)
        } else {
          openNotificationWithIcon('error', '消息提示', error_msg)
        }

      },
      error => {
        navigate("/error");
      }
    )
  }

  //添加或者修改
  function handleAddOrModify() {
    let valiad = true;
    //校验
    const { attributeName, attributeType, id } = state;
    const items = [
      { name: 'attributeName', val: attributeName },
      { name: 'attributeType', val: attributeType }
    ];
    let success_msg = "";
    let error_msg = "";
    if (id) {
      success_msg = "数据修改成功！";
      error_msg = "数据修改失败！";
    } else {
      success_msg = "数据新增成功！";
      error_msg = "数据新增失败！";
    }

    items.map(item => {
      if (!item.val) {
        valiad = false;
        return setState(prevState => ({ ...prevState, [item.name + '_isVisible']: true }));
      }
      return null;
    })
    if (valiad) {
      const attributeArr = [];
      for (let i = 0; i < attributeData.length; i++) {
        attributeArr.push(attributeValObj['k_' + attributeData[i].key]);
      }
      const data = {
        id,
        name: attributeName,
        type: attributeType,
        valueList: attributeArr
      }
      //请求后台接口
      axios.defaults.headers.common['token'] = token;
      axios.post('/api/attribute/addOrModify',
        data, {
        headers: {
          'Content-Type': 'application/json'
        }
      }
      ).then(
        response => {
          if (response.data.code === "200") {
            openNotificationWithIcon('success', '消息提示', success_msg)
            queryList(query);
            setOpen(false);
            setAttributeData([]);
            setAttributeValObj({});
          } else {
            openNotificationWithIcon('error', '消息提示', error_msg + response.data.msg)
            setOpen(true);
          }

        },
        error => {
          navigate("/error");
        }
      )
    } else {
      setOpen(true);
    }
  }
  //组装Serach组件的查询字段
  const searchFields = [
    {
      fieldName: 'type',
      fieldCnName: '属性类别',
      placeholder: '请选择属性类别',
      fieldType: 'select',
      optionData: [
        { value: 1, label: '蔬菜' },
        { value: 2, label: '干果' },
        { value: 3, label: '粮油' },
        { value: 4, label: '肉类' },
        { value: 5, label: '海鲜' },
        { value: 6, label: '水产' }
      ]
    },
    {
      fieldName: 'name',
      fieldCnName: '属性名称',
      placeholder: '请输入属性名称'
    }
  ]


  const handleSearch = (data) => {
    setQuery(data);
    queryList(data);
  };
  const inputChange = (event) => {
    if (!event.target.value) {
      setState({
        ...state,
        [event.target.name]: '',
        [event.target.name + '_isVisible']: true,
      })
    } else {
      setState({
        ...state,
        [event.target.name]: event.target.value,
        [event.target.name + '_isVisible']: false,
      })
    }
  }

  const columns = [
    {
      title: '属性类别',
      dataIndex: 'attributeType',
      key: 'attributeType',
      fixed: 'left',
      align: 'center',
      responsive: ['lg'],
      render: (_, record) => {
        let name = "蔬菜";
        switch (record.attributeType) {
          case 1:
            name = "蔬菜";
            break;
          case 2:
            name = "干果";
            break;
          case 3:
            name = "粮油";
            break;
          case 4:
            name = "肉类";
            break;
          case 5:
            name = "海鲜";
            break;
          case 6:
            name = "水产";
            break;
          default:
            break;
        }
        return <span>{name}</span>;
      }
    }, {
      title: '属性名称',
      dataIndex: 'attributeName',
      key: 'attributeName',
      fixed: 'left',
      align: 'center',
      responsive: ['lg'],
    },
    {
      title: '操作',
      key: 'operation',
      align: 'center',
      responsive: ['lg'],
      render: (_, record) => (
        <div>
          <a onClick={() => modifyAttribute(record.id)} style={{ marginRight: '20px' }}>编辑</a>
          <a onClick={() => deleteAttribute(record.id)} style={{ marginRight: '20px', color: '#FF0000' }} >删除</a>
        </div>
      )
    },
  ];

  const addGoodsAttributeCard = () => {
    let currentTime = Date.now();
    setAttributeData([...attributeData, { key: currentTime + '' }]);
    setAttributeValObj({ ...attributeValObj, ['k_' + currentTime]: '' })
  };

  const removeGoodsAttributeCard = (key) => {
    const objkey = 'k_' + key;
    delete attributeValObj[objkey];
    setAttributeData(attributeData.filter(obj => obj.key !== key));
  };
  const handleAttributeChange = (e, datakey) => {
    if (e.target.name == 'attributeValue') {
      setAttributeValObj({ ...attributeValObj, ['k_' + datakey]: e.target.value })
    }
  }

  return (
    <React.Fragment>
      {contextHolder}
      <div className="item-location">
        当前所在位置 : 属性管理
      </div>

      <Serach fields={searchFields} initState={initialFields} onSearch={handleSearch} />

      <div className="data-div">
        <div className="bt_group">
          <Button onClick={showModal} className="bt_group_add"><PlusOutlined />新增</Button>
          <Button className="bt_group_batch_close" onClick={() => handleBatchDel()}><DeleteOutlined />批量删除</Button>
        </div>
        <ConfigProvider locale={zhCN}>
          <Table
            columns={columns}
            rowKey="id"
            dataSource={dataSource}
            rowSelection={rowSelection}
            bordered
            pagination={{ position: ['bottomCenter'], hideOnSinglePage: 'true' }}
            scroll={{ x: 1500 }}
            sticky={{ offsetHeader: 0 }}
          />
        </ConfigProvider>
      </div>

      <Modal
        open={open}
        title={modalTitle}
        onOk={handleOk}
        onCancel={handleCancel}
        width={1000}
        centered={true}
        cancelText="取消"
        okText="确定"
        maskClosable={false}
      >
        <div>
          <div className="modal_field_style">
            <div className="modal_field_name_style">
              <span style={{ color: 'red' }}>*</span>
              <span>属性名称:</span>
            </div>
            <div style={{ width: '90%' }}><Input size="large" placeholder="请输入属性名称" name='attributeName' value={state.attributeName} onChange={inputChange} /></div>
          </div>
          <div className="modal_field_tip_style">
            <div style={{ width: '89%' }}><span className={state.attributeName_isVisible ? 'tip-msg-show' : 'tip-msg-hidden'}>请输入属性名称</span></div>
          </div>

          <div className="modal_field_style_2">
            <div className="modal_field_name_style">
              <span>属性类别:</span>
            </div>
            <div style={{ width: '90%' }}>
              <Radio.Group name="attributeType" value={state.attributeType} onChange={inputChange}
                options={[
                  { value: 1, label: '蔬菜' },
                  { value: 2, label: '干果' },
                  { value: 3, label: '粮油' },
                  { value: 4, label: '肉类' },
                  { value: 5, label: '海鲜' },
                  { value: 6, label: '水产' }
                ]}
              />
            </div>
          </div>
          <div className="modal_field_style_2">
            <div style={{ width: '100%', marginTop: '20px' }}>
              <Card title="属性值" extra={<a onClick={addGoodsAttributeCard}><PlusOutlined /></a>}>
                {attributeData.map(data => (
                  <div key={data.key} style={{ width: '100%', marginTop: '10px', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                    <div style={{ width: '50%', paddingLeft: '10px', paddingRight: '10px', display: 'flex', justifyContent: 'center', alignItems: 'center' }}><span style={{ width: '15%' }}>属性值</span><Input size="large" placeholder="请输入属性值" name='attributeValue' value={attributeValObj['k_' + data.key]} onChange={(e) => handleAttributeChange(e, data.key)} /></div>
                    <a onClick={() => removeGoodsAttributeCard(data.key)}><MinusOutlined /></a>
                  </div>
                ))}
              </Card>
            </div>
          </div>


        </div>
      </Modal>
    </React.Fragment>

  )
}
